// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1fSEA","footer":"styles_footer__1_p-f"};